import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import * as R from "ramda";
import { format } from "date-fns";

import { DateWithModal } from "../../../_common/dateWithModal";

export const DossiersFilter = ({ creationUsersOptions, statusOptions, searchRef, pageSearch, setPageSearch, routerQuery, creationUser, pageQuery, teleconseillers, userId }) => {
	const history = useHistory();

	const creationUserParam = pageQuery.get("creationUser");
	const statusParam = pageQuery.get("status");

	const [date, setDate] = useState({ startDate: routerQuery.fromCreationDate ? new Date(routerQuery.fromCreationDate) : undefined, endDate: routerQuery.toCreationDate ? new Date(routerQuery.toCreationDate) : undefined });
	useEffect(() => {
	}, [teleconseillers]);

	console.log('routerQuery', routerQuery)
	return (
		<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
			<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
				<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
				<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
			</button>
			<div className="collapse navbar-collapse flex-column" id="navbarNav">
				<form className="form-inline container-default mx-auto justify-content-center" id="filterForm" onSubmit={(e) => e.preventDefault()}>
					<div className={"my-1 input-group btn-dim rounded-max mr-2 ml-xl-auto" + (pageSearch !== "" ? " active" : "")}>
						<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" ref={searchRef} aria-label="Recherche" value={pageSearch} onChange={(e) => setPageSearch(e.target.value)} />
						<div className="input-group-prepend rounded-inherit">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
								<i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
						</div>
					</div>
					<div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert active" role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonCreationUser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{!R.isNil(creationUserParam)
								? creationUserParam === userId
									? "Mes dossiers"
									: creationUserParam !== "00000000-0000-0000-0000-000000000000"
									? `Chargé : ${teleconseillers?.find((item) => item.id === creationUserParam)?.firstName}  ${teleconseillers?.find((item) => item.id === creationUserParam)?.lastName}`
									: "Non affectés"
								: "Tous les dossiers"}
						</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonCreationUser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-activity-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonCreationUser">
								{/* <Link className={"dropdown-item py-2 h6 mb-0 " + (!R.isNil(creationUserParam) ? "active" : "")} type="button" to={`/funecap/dossiers?page=${1}&creationUser=${creationUser}${pageSearch !== "" ? "&search=" + pageSearch : ""}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`}>Mes dossiers</Link>
								<Link className={"dropdown-item py-2 h6 mb-0 " + (R.isNil(creationUserParam) ? "active" : "")} type="button" to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`}>Tous les dossiers</Link> */}

								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (!R.isNil(creationUserParam) && creationUserParam === userId ? "active" : "")}
									type="button"
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("creationUser", userId);
										return `/funecap/dossiers?${searchParams}`;
									}}>
									Mes dossiers
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (R.isNil(creationUserParam) ? "active" : "")}
									type="button"
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.delete("creationUser");
										return `/funecap/dossiers?${searchParams}`;
									}}>
									Tous les dossiers
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (!R.isNil(creationUserParam) && creationUserParam === "00000000-0000-0000-0000-000000000000" ? "active" : "")}
									type="button"
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("creationUser", "00000000-0000-0000-0000-000000000000");
										return `/funecap/dossiers?${searchParams}`;
									}}>
									Non affectés
								</Link>
								{teleconseillers
									?.filter((item) => {
										return item.roles.includes("etablissement");
									})
									.sort((a, b) => a.lastName.localeCompare(b.lastName))
									.map((item, index) => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("creationUser", item.id);
										return (
											<Link key={index} type="button" className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.creationUser === item.id ? " active" : "")} to={`/funecap/dossiers?${searchParams}`}>
												{`${item.firstName} ${item.lastName.toUpperCase()}`}
											</Link>
										);
									})}
							</div>
						</div>
					</div>

					{/* <div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert active" role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{`Statut: ${!R.isNil(statusParam) ? statusOptionsFilter[statusParam] : "Non archivés"}`}
						</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-activity-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonStatuts">
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (R.isNil(statusParam) ? "active" : "")}
									type="button"
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.delete("status");
										return `/funecap/dossiers?${searchParams}`;
									}}>
									Non archivés
								</Link>
								{Object.entries(statusOptionsFilter).map(([key, value]) => {
									const searchParams = new URLSearchParams(window.location.search);
									searchParams.set("status", key);
									return (
										<Link key={key} type="button" className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.status === key ? " active" : "")} to={`/funecap/dossiers?${searchParams}`}>
											{value}
										</Link>
									);
								})}
							</div>
						</div>
					</div> */}

					<div className={"my-1 input-group btn-dim rounded-max mr-2 btn-alert" + (Object.keys(statusOptions).includes(routerQuery.type) ? " active" : " ")} role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{R.isEmpty(routerQuery.type) || !Object.keys(statusOptions).includes(routerQuery.type) ? "Tous les statuts" : statusOptions[routerQuery.type]}
						</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-activity-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonStatuts">
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.type === "facilitaOngoing" ? "active" : "")}
									type="button"
									to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${"&type=facilitaOngoing"}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${
										routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
									}`}>
									En cours
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.type === "facilitaNotAccepted" ? "active" : "")}
									type="button"
									to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${"&type=facilitaNotAccepted"}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${
										routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
									}`}>
									N'a pas accepté
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.type === "facilitaSending" ? "active" : "")}
									type="button"
									to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${"&type=facilitaSending"}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${
										routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
									}`}>
									A envoyer
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.type === "facilitaOvertime" ? "active" : "")}
									type="button"
									to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${"&type=facilitaOvertime"}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${
										routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
									}`}>
									Courriers générés
								</Link>
							</div>
						</div>
					</div>
					<DateWithModal
						selectedDate={date.startDate}
						setSelectedDate={(dateCalendar) => {
							setDate({ ...date, startDate: dateCalendar });
							const searchParams = new URLSearchParams(window.location.search);
							searchParams.set("fromCreationDate", format(dateCalendar, "yyyy-MM-dd"));
							history.push(`/funecap/dossiers?${searchParams}`);
						}}
						isRequired={true}
						classToolbar={true}
					/>
					<div className="d-inherit mx-2 text-gray">-</div>
					<DateWithModal
						selectedDate={date.endDate}
						setSelectedDate={(dateCalendar) => {
							setDate({ ...date, endDate: dateCalendar });
							const searchParams = new URLSearchParams(window.location.search);
							searchParams.set("toCreationDate", format(dateCalendar, "yyyy-MM-dd"));
							history.push(`/funecap/dossiers?${searchParams}`);
						}}
						isRequired={true}
						classToolbar={true}
					/>
					<div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert active" role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{R.isNil(statusParam) ? "Archivés: non" : "Archivés: oui"}
						</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-archive-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonStatuts">
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (!R.isNil(statusParam) ? "active" : "")}
									type="button"
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("status", "all");
										return `/funecap/dossiers?${searchParams}`;
									}}>
									Archivés: oui
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (R.isNil(statusParam) ? "active" : "")}
									type="button"
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.delete("status");
										return `/funecap/dossiers?${searchParams}`;
									}}>
									Archivés: non
								</Link>
							</div>
						</div>
					</div>
					<div className={"my-1 input-group btn-dim rounded-max mx-2 btn-alert active"} role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							{routerQuery.sortBy === "lastName" ? "Ordre alphabétique" : "Les plus récents"}
						</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-funnel-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButton">
								{/* <button className={"dropdown-item py-2 h6 mb-0 " + (!dossierState.globalFilters.order.asc ? "active" : "")} type="button" onClick={() => dispatch(setFilterGlobal({ order: { column: "lastName", asc: false } }))}>Les plus récents</button>
								<button className={"dropdown-item py-2 h6 mb-0 " + (dossierState.globalFilters.order.asc ? "active" : "")} type="button" onClick={() => dispatch(setFilterGlobal({ order: { column: "lastName", asc: true } }))}>Ordre alphabétique</button> */}
								{/* <Link className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "creationDate" ? "active" : "")} to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.type !== "" ? "&type=" + routerQuery.type : ""}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${"&sortBy=creationDate"}${"&sortDesc=true"}`} type="button" >Les plus récents</Link>
								<Link className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "lastName" ? "active" : "")} to={`/funecap/dossiers?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.type !== "" ? "&type=" + routerQuery.type : ""}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${"&sortBy=lastName"}${"&sortDesc=false"}`} type="button">Ordre alphabétique</Link>
								 */}
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "creationDate" ? "active" : "")}
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("sortBy", "creationDate");
										searchParams.set("sortDesc", "true");
										return `/funecap/dossiers?${searchParams}`;
									}}
									type="button">
									Les plus récents
								</Link>
								<Link
									className={"dropdown-item py-2 h6 mb-0 " + (routerQuery.sortBy === "lastName" ? "active" : "")}
									to={() => {
										const searchParams = new URLSearchParams(window.location.search);
										searchParams.set("sortBy", "lastName");
										searchParams.set("sortDesc", "false");
										return `/funecap/dossiers?${searchParams}`;
									}}
									type="button">
									Ordre alphabétique
								</Link>
							</div>
						</div>
					</div>
					<div className="divider-vertical mx-3"></div>
					<Link type="button" className="btn btn-white-primary rounded-max p-0 mr-2" to={"/funecap/dossiers/create"}>
						<p className="form-control my-auto small">Créer un dossier</p>
						<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
							<i className="eva eva-plus-outline align-middle fs-root lh-xs"></i>
						</div>
					</Link>
				</form>
			</div>
			<span className="small font-weight-bold">
				Besoin d'aide ?{" "}
				<a className="text-info" href="/faqs">
					FAQ
				</a>
			</span>
		</nav>
	);
};
